<template>
  <Feed
    :item-id="itemId"
    :title="title"
    order-by="interactions"
    v-bind="$attrs"
  />
</template>

<script>
import Feed from '@/components/cards/models/Feed';

export default {
  name: 'TopPostsByInteractions',
  components: {
    Feed,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>
